import React, { useState } from 'react';
import ProductionComponent from './ProductionComponent';
import { withRouter, Link } from 'react-router-dom';

const ProductionContainer = props => {
    const [selectedProductionIdx, setSelectedProductionIdx] = useState(0);

    const onClickAnchor = (evt, anchorId) => {
        evt.preventDefault();
        props.history.push(`/about/production#${anchorId}`);
    }
    const onClickBtnProduction = (evt, idx) => {
        console.log('onClickBtnProduction', idx);
        setSelectedProductionIdx(idx);
        if (idx > 1) {
            document.body.style.position = 'fixed';
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.position = 'relative';
            document.body.style.overflow = 'auto';
        }
    }
    return (
        <ProductionComponent
            onClickAnchor={onClickAnchor}
            onClickBtnProduction={onClickBtnProduction}
            selectedProductionIdx={selectedProductionIdx}
            {...props} />
    )
}

export default withRouter(ProductionContainer);